import React, { useState, useEffect } from "react";
import { Table, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useAppContext } from "../../../context/appContext";
import { isViewOnly } from "../../../utils/permissions";
import { Paginate } from "../../../components";
import { EditMeasurementTechModal } from "./UpdateTech/EditMeasurementTechModal";
import { DeleteMeasurementTechModal } from "./UpdateTech/DeleteMeasurementTechModal";

const MeasurementTechListPage = ({ env, handleEnvChange, technologies, isLoading, isError, pageResetFlag, currentTenant }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTechnology, setSelectedTechnology] = useState(null);

  const { user } = useAppContext();

  const viewOnly = isViewOnly(user);

  const itemsPerPage = 8;
  const indexOfLastTechnology = currentPage * itemsPerPage;
  const indexOfFirstTechnology = indexOfLastTechnology - itemsPerPage;
  const currentTechnology = technologies?.slice(indexOfFirstTechnology, indexOfLastTechnology);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = technologies?.length ? Math.ceil(technologies?.length / itemsPerPage) : 0;

  const formatDateWithObject = (isoDateString) => {
    const date = new Date(isoDateString);
    return date.toISOString().split("T")[0];
  };

  const handleEditClick = (selectedTechnology) => {
    setSelectedTechnology(selectedTechnology);
    setShowModal(true);
  };

  const handleDeleteClick = (selectedTechnology) => {
    setSelectedTechnology(selectedTechnology);
    setShowDeleteModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTechnology(null);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedTechnology(null);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [pageResetFlag, technologies]);

  return (
    <Container fluid>
      {!isLoading && !isError && (
        <Table striped bordered hover responsive className="table-sm">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col" style={{ width: "650px" }}>
                Description
              </th>
              <th scope="col">Created By</th>
              <th scope="col">Date Created</th>
              <th scope="col" style={{ width: "80px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {currentTechnology?.map((selectedTechnology) => (
              <tr key={selectedTechnology?.id}>
                <td>{selectedTechnology?.name}</td>
                <td>{selectedTechnology?.description}</td>
                <td>{selectedTechnology?.createdBy}</td>
                <td>{formatDateWithObject(selectedTechnology?.dateCreated)}</td>
                <td>
                  <div className="d-flex justify-content-around align-items-center" style={{ minWidth: "80px" }}>
                    {viewOnly ? (
                      <FontAwesomeIcon icon={faEye} style={{ cursor: "pointer" }} onClick={() => handleEditClick(selectedTechnology)} />
                    ) : (
                      <>
                        <FontAwesomeIcon
                          icon={faEdit}
                          style={{ cursor: "pointer", marginRight: "10px" }}
                          onClick={() => handleEditClick(selectedTechnology)}
                        />
                        <FontAwesomeIcon
                          icon={faTimes}
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() => handleDeleteClick(selectedTechnology)}
                        />
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {!isLoading && !isError && <Paginate currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />}

      {selectedTechnology && (
        <>
          <EditMeasurementTechModal
            show={showModal}
            technology={selectedTechnology}
            handleClose={handleCloseModal}
            viewOnly={viewOnly}
            handleEnvChange={handleEnvChange}
            currentTenant={currentTenant}
            env={env}
          />
          {!viewOnly && (
            <DeleteMeasurementTechModal
              show={showDeleteModal}
              technology={selectedTechnology}
              handleClose={handleCloseDeleteModal}
              handleEnvChange={handleEnvChange}
              currentTenant={currentTenant}
              env={env}
            />
          )}
        </>
      )}
    </Container>
  );
};

export default MeasurementTechListPage;
